var map = {
	"./donlon.svg": 124,
	"./enchai.svg": 125,
	"./falconator.svg": 72,
	"./jebing.svg": 126,
	"./lerbin.svg": 127,
	"./pingasor.svg": 128,
	"./planet.svg": 129,
	"./pod.svg": 130,
	"./rocket.svg": 131,
	"./sapir.svg": 132,
	"./ship.svg": 133,
	"./shuttle.svg": 134,
	"./tiny-falconator.png": 73,
	"./vehicle.svg": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;